





define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        return function() {
            return {
                additionalData: requestFactory.single(endpoints.adp, ApiKeyNames.search)
            };
        };
    }
);



// WEBPACK FOOTER //
// ./rest/additionalData.js